import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { CoreModule } from 'src/app/core/core.module';
import { TagModule } from 'primeng/tag';
import { AccordionModule } from 'primeng/accordion';
import { UseComponent } from './use.component';
import { UseRoutingModule } from './use-routing.module';
import { ChartModule } from 'primeng/chart';

@NgModule({ declarations: [
        UseComponent,
    ], imports: [UseRoutingModule,
        CoreModule,
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        DropdownModule,
        MultiSelectModule,
        ConfirmDialogModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        DropdownModule,
        DialogModule,
        CalendarModule,
        TagModule,
        AccordionModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class UseModule { }